export default __webpack_public_path__ + "static/media/gamification-img-yellow.1614261b.png";